import React, { useEffect } from 'react';
import { HeaderContainer } from '../styles';
import HeaderFilters from './headerFilters';
import HeaderSearch from './headerSearch';
import HeaderTitlebar from './headerTitlebar';
import { notificationPanelActions } from '../context';
import { WebSocketService } from '@lua-frontend/utils';

const Header = ({ service, isOpen, dispatch, notifications, filterOptions, pagination }) => {
  const createNotificationPayload = (filters, pagination) => {
    const payload = {
      limit: pagination.limit,
      offset: pagination.offset
    };

    if (filters.searchValue) {
      payload.search = filters.searchValue;
    }

    if (filters.isUnRead) {
      payload.isUnRead = true;
    }

    payload.type = filters.selectedType ?? 'all';
    // if (filters.selectedType && filters.selectedType !== 'all') {
    //   payload.type = filters.selectedType;
    // }

    if (filters.selectedSubTypes?.length) {
      payload.subTypes = filters.selectedSubTypes;
    }

    return payload;
  };

  useEffect(() => {
    // Do nothing if drawer is closed
    if (!isOpen) {
      // cancel any in-flight request when closing
      if (service.getToken?.cancel) {
        service.getToken.cancel('axios cancel');
      }

      return;
    }


    dispatch(notificationPanelActions.resetPagination());
  }, [filterOptions.searchValue, filterOptions.isUnRead, filterOptions.selectedType, filterOptions.selectedSubTypes, isOpen, service, dispatch]);

  useEffect(() => {
    if (isOpen && pagination.isLoading) {
      service
        .getNotifications(createNotificationPayload(filterOptions, pagination))
        .then((response) => {
          const hasMore = response && response.length >= pagination.limit;
          dispatch(notificationPanelActions.appendNotifications(response || [], hasMore));
        })
        .catch((error) => {
          console.error('get notifications error', error);
          dispatch(
            notificationPanelActions.updatePagination({
              isLoading: false
            })
          );
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, pagination.isLoading]);

  const isSocketConnected = WebSocketService.isConnected();

  useEffect(() => {
    const socketEventList = WebSocketService.getEventList();

    WebSocketService.on(socketEventList.EMPLOYEE.NOTIFICATION.NEW, (response) => {
      dispatch(notificationPanelActions.addNotification(response));
    });

    WebSocketService.on(socketEventList.EMPLOYEE.NOTIFICATION.UPDATE, (response) => {
      dispatch(notificationPanelActions.updateNotification(response));
    });

    return () => {
      WebSocketService.off(socketEventList.EMPLOYEE.NOTIFICATION.NEW);
      WebSocketService.off(socketEventList.EMPLOYEE.NOTIFICATION.UPDATE);
    };
  }, [dispatch, isSocketConnected]);

  const onMarkAllAsRead = () => {
    const oldNotifications = [...notifications];
    const newNotifications = notifications.map((n) => ({
      ...n,
      recipients: n.recipients.map((r) => ({ ...r, isRead: true, readAt: new Date() }))
    }));

    dispatch(notificationPanelActions.setNotifications(newNotifications));

    service.readAllNotifications().catch((error) => {
      console.log('error', error);
      dispatch(notificationPanelActions.setNotifications(oldNotifications));
    });
  };

  return (
    <HeaderContainer>
      <HeaderTitlebar onMarkAllAsRead={onMarkAllAsRead} />
      <HeaderSearch />
      <HeaderFilters />
    </HeaderContainer>
  );
};

export default Header;
